<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M0,8C0,12.42,3.58,16,8,16C12.42,16,16,12.42,16,8C16,3.58,12.42,0,8,0C3.58,0,0,3.58,0,8ZM11.29,5.29C11.47,5.11,11.72,5,12,5C12.55,5,13,5.45,13,6C13,6.28,12.89,6.53,12.71,6.71L7.71,11.71C7.53,11.89,7.28,12,7,12C6.72,12,6.47,11.89,6.29,11.71L3.29,8.71C3.11,8.53,3,8.28,3,8C3,7.45,3.45,7,4,7C4.28,7,4.53,7.11,4.71,7.29L7,9.59L11.29,5.29Z"
          fill-rule="evenodd"
          fill="#52BD94"
          fill-opacity="1"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Success',
} as DefineComponent
</script>
